var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWsSamoa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_25598)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0V45H60V0Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H30V22.5H60V0Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1248 21.4969L45.0654 20.1844L46.9311 21.5062L46.3217 19.1719L48.1029 17.7469L45.8061 17.6062L45.0467 15.3937L44.2217 17.6437L41.9717 17.7094L43.7529 19.2375L43.1248 21.4969ZM43.4623 5.97187L45.0186 4.96875L46.5186 5.94375L46.1061 4.06875L47.4748 2.87812L45.6561 2.72812L44.9811 0.984375L44.2873 2.7375L42.4967 2.89687L43.8748 4.15312L43.4623 5.97187ZM50.3061 11.55L51.8061 10.5187L53.3717 11.55L52.8842 9.73125L54.2998 8.53125L52.4998 8.4375L51.8436 6.65625L51.2061 8.42812L49.3686 8.53125L50.7748 9.70312L50.3061 11.55ZM36.5623 10.3125L38.0061 9.375L39.4123 10.3125L38.9998 8.59687L40.3123 7.49062L38.5967 7.35L38.0061 5.7375L37.3498 7.36875L35.6904 7.4625L36.9748 8.61562L36.5623 10.3125ZM40.6029 14.3812L41.5686 13.7812L42.5342 14.4L42.2811 13.2469L43.1436 12.4687L42.0186 12.375L41.5873 11.2875L41.1279 12.375L40.0123 12.4687L40.8654 13.2469L40.6029 14.3812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_25598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsSamoa);
export default __webpack_public_path__ + "static/media/ws Samoa.e3e74717561846c1e83b03d98d00cd67.svg";
export { ForwardRef as ReactComponent };